'use client';

import React from 'react';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useGetRouteStopsQuery } from 'src/api/redux';
import { PulseButton } from 'src/components/PulseUI/PulseButton';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import {
  selectPreviewRoute,
  setPreviewRoute,
} from 'src/redux/slices/routesSlice';

/**
 * Names the route previewed on the map (Scout's "View Route on Map") and clears
 * it. Renders nothing when no route is previewed.
 */
const RoutePreviewControl = () => {
  const dispatch = useAppDispatch();
  const previewRoute = useAppSelector(selectPreviewRoute);
  const { isError } = useGetRouteStopsQuery(previewRoute?.id ?? '', {
    skip: !previewRoute,
  });

  if (!previewRoute) return null;

  return (
    <div
      className="flex max-w-64 items-center gap-1 rounded-lg bg-white py-1 pl-3 pr-1 shadow-[0px_8px_8px_0px_rgba(0,0,0,0.08)] outline outline-1 outline-offset-[-1px] outline-neutral-300"
      data-testid="route-preview-control"
    >
      <span
        className="truncate text-sm font-medium text-neutral-800"
        data-testid="route-preview-label"
      >
        {isError
          ? 'Route unavailable'
          : previewRoute.label || `Route ${previewRoute.id}`}
      </span>
      <PulseButton
        variant="plain"
        color="neutral"
        size="xs"
        startDecorator={faXmark}
        onClick={() => dispatch(setPreviewRoute(null))}
        aria-label="Clear route from map"
        data-testid="route-preview-clear"
      />
    </div>
  );
};

export default RoutePreviewControl;
